/*
 *
 * PerformRegularSecurityTests
 *
 * @version 1.0.0
 * @author GitHub Copilot
 * @since 04-Sep-2025
*/

import PerformRegularSecurityTests from './PerformRegularSecurityTestsContainer'

export default PerformRegularSecurityTests
